import { useTranslation } from 'next-i18next'
import Image from 'next/future/image'
import { useState } from 'react'
import ReviewForm from './ReviewForm'
import { useSelector } from 'react-redux'
import { selectMe } from '../../features/auth/authReducer'
import Alert from '../Alert'

export default function PluginRating ({ plugin, ratingStats, onReviewCreated }) {
  const { t } = useTranslation(['plugins'])

  const [toggleForm, setToggleForm] = useState(false)
  const [toggleAlert, setToggleAlert] = useState(false)

  const me = useSelector(state => selectMe(state.auth))
  const handleOnReviewCreated = () => {
    onReviewCreated()
    setToggleAlert(true)
  }

  return (
    <div>
      <span className="d-flex align-items-center text-dark">
        <h3 className="fs-3 fw-bold me-3 my-0">{t('detail.rating.rating')}:</h3>
        <span className="d-flex align-items-center">
          <Image alt=""
            src="/images/icons/star-default.png"
            width={20}
            height={20}
            className="me-1"
          />
          <span className="fs-3">{ Math.round(plugin.rating_total) }</span>
        </span>
      </span>
      <div className="mt-3">
        <div className="row align-items-center">
          <span className="col-3">5 {t('detail.rating.stars')}</span>
          <div className="bg-muted col-7 p-0 rounded position-relative">
            <div className="bg-primary rounded"
              style={{ width: `${ratingStats.stars[4]}%`, height: '100%', minHeight: '31px' }}
            />
          </div>
          <span className="text-muted col-auto text-end ms-auto">
            <small>{ ratingStats.stars[4] }%</small>
          </span>
        </div>
        <div className="row align-items-center mt-2">
          <span className="col-3">4 {t('detail.rating.stars')}</span>
          <div className="bg-muted col-7 p-0 rounded">
            <div className="bg-primary rounded"
              style={{ width: `${ratingStats.stars[3]}%`, height: '100%', minHeight: '31px' }}
            />
          </div>
          <span className="text-muted col-auto text-end ms-auto">
            <small>{ ratingStats.stars[3] }%</small>
          </span>
        </div>
        <div className="row align-items-center mt-2">
          <span className="col-3">3 {t('detail.rating.stars')}</span>
          <div className="bg-muted col-7 p-0 rounded">
            <div className="bg-primary rounded"
              style={{ width: `${ratingStats.stars[2]}%`, height: '100%', minHeight: '31px' }}
            />
          </div>
          <span className="text-muted col-auto text-end ms-auto">
            <small>{ ratingStats.stars[2] }%</small>
          </span>
        </div>
        <div className="row align-items-center mt-2">
          <span className="col-3">2 {t('detail.rating.stars')}</span>
          <div className="bg-muted col-7 p-0 rounded">
            <div className="bg-primary rounded"
              style={{ width: `${ratingStats.stars[1]}%`, height: '100%', minHeight: '31px' }}
            />
          </div>
          <span className="text-muted col-auto text-end ms-auto">
            <small>{ ratingStats.stars[1] }%</small>
          </span>
        </div>
        <div className="row align-items-center mt-2">
          <span className="col-3">1 {t('detail.rating.stars')}</span>
          <div className="bg-muted col-7 p-0 rounded">
            <div className="bg-primary rounded"
              style={{ width: `${ratingStats.stars[0]}%`, height: '100%', minHeight: '31px' }}
            />
          </div>
          <span className="text-muted col-auto text-end ms-auto">
            <small>{ ratingStats.stars[0] }%</small>
          </span>
        </div>
      </div>
      <div className="mt-5">
        <div className="d-flex justify-content-between align-items-center">
          <span>{t('detail.rating.functionality')}</span>
          <span className="d-flex align-items-center">
            <Image alt=""
              src="/images/icons/star-default.png"
              width={16}
              height={16}
              className="me-2"
            />
            {Math.round(plugin.rating_total_functionality)}
          </span>
        </div>
        <div className="d-flex justify-content-between mt-3 align-items-center">
          <span>{t('detail.rating.documentation')}</span>
          <span className="d-flex align-items-center">
            <Image alt=""
              src="/images/icons/star-default.png"
              width={16}
              height={16}
              className="me-2"
            />
            {Math.round(plugin.rating_total_documentation)}
          </span>
        </div>
        <div className="d-flex justify-content-between mt-3 align-items-center">
          <span>{t('detail.rating.support')}</span>
          <span className="d-flex align-items-center">
            <Image alt=""
              src="/images/icons/star-default.png"
              width={16}
              height={16}
              className="me-2"
            />
            {Math.round(plugin.rating_total_support)}
          </span>
        </div>
      </div>
      { (me && me.id) && (
        <button
          className="btn btn-sm btn-outline-primary mt-4 mt-lg-5"
          onClick={() => setToggleForm(true)}
        >{t('detail.rating.write_review')}</button>
      )}
      { toggleForm && (
        <ReviewForm
          onReviewCreated={handleOnReviewCreated}
          plugin={plugin}
          onToggleChange={setToggleForm}
        />
      )}
      { toggleAlert && (
        <Alert variant="success"
          toggleOut={true}
        >
          <span>{t('detail.rating.form.alert')}</span>
        </Alert>
      )}
    </div>
  )
}
